import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { keysToCamel } from '@shared/helpers';
import { IDataResponse, IDataResponseError } from '@shared/model/types/dataResponse.inteface';
import { getEnablePoll } from '@widgets/UserPoll/api/getEnablePoll';

type PollEnableApiResponse = AxiosResponse<IDataResponse<{ need: boolean }>>;
type PollEnableData = IDataResponse<{ need: boolean }>;

export const useGetPollEnable = () =>
    useQuery<PollEnableApiResponse, IDataResponseError, PollEnableData>({
        queryKey: ['enable-poll'],
        queryFn: getEnablePoll,
        staleTime: Infinity,
        gcTime: Infinity,
        // cacheTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        retry: false,
        select: (data) => keysToCamel<IDataResponse<{ need: boolean }>>(data.data),
    });
